import React, { useState, ReactNode } from 'react';
import { classnames } from '../operations';
import {
  CheckboxWrapper,
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  Icon,
  CheckboxLabel
} from './Checkbox.styles';

type OnChange = (checked: boolean) => void;

export type CheckboxProps = {
  id: string;
  label?: string|ReactNode;
  onChange?: OnChange;
  value?: boolean;
  isDisabled?: boolean;
  testHook?: string;
  className?: string;
  boxClassName?: string;
  labelClassName?: string;
};

const Checkbox = ({
  id,
  label = '',
  onChange = () => {},
  value = false,
  isDisabled = false,
  testHook = 'Checkbox',
  className = '',
  boxClassName = '',
  labelClassName = '',
  ...rest
}: CheckboxProps) => {
  const [checkboxValue, setValue] = useState(value);
  const [isFocused, setFocused] = useState(false);
  const classNames = classnames({ 'is-disabled': isDisabled }, [className]);
  const boxClassNames = classnames({ 'is-disabled': isDisabled, 'is-focused': isFocused }, [boxClassName]);
  const labelClassNames = classnames({ 'is-disabled': isDisabled }, [labelClassName]);

  const handleOnChange = () => {
    const newValue = !checkboxValue;
    setValue(newValue);
    onChange(newValue);
  };

  const handleOnFocus = () => {
    setFocused(!isFocused);
  };

  return (
    <CheckboxWrapper htmlFor={id} data-cv-test={testHook} className={classNames}>
      <CheckboxContainer>
        <HiddenCheckbox
          id={id}
          checked={checkboxValue}
          onChange={!isDisabled ? handleOnChange : () => {}}
          onFocus={handleOnFocus}
          onBlur={handleOnFocus}
          {...rest}
        />
        <StyledCheckbox
          className={boxClassNames}
          data-cv-test={`${testHook}Styled`}
          checked={checkboxValue}
          focused={isFocused}
        >
          <Icon
            className={boxClassNames}
            viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      <CheckboxLabel htmlFor={id} className={labelClassNames}>{label}</CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default Checkbox;
